module.exports = __webpack_public_path__ + "static/rubin-nsf-small-logo-70fba11d7102137c7a4375bd9cc448ff.png";